/**
 * @generated SignedSource<<7ec9644c39438e327ebd818c83b9b3c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateTodoNumberResponseInput = {
  number?: number | null;
};
export type TodoResponseNumberScreenMutation$variables = {
  input: UpdateTodoNumberResponseInput;
  todoId: string;
};
export type TodoResponseNumberScreenMutation$data = {
  readonly todo: {
    readonly updateNumberResponse: {
      readonly isResponseCompleted: boolean;
      readonly response: {
        readonly value?: number | null;
      } | null;
    };
  } | null;
};
export type TodoResponseNumberScreenMutation = {
  response: TodoResponseNumberScreenMutation$data;
  variables: TodoResponseNumberScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "todoId",
    "variableName": "todoId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isResponseCompleted",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "type": "TodoResponseNumber",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoResponseNumberScreenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateNumberResponse",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "response",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoResponseNumberScreenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateNumberResponse",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "response",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c4231a228fbf3769d3a71ad0f6f78457",
    "id": null,
    "metadata": {},
    "name": "TodoResponseNumberScreenMutation",
    "operationKind": "mutation",
    "text": "mutation TodoResponseNumberScreenMutation(\n  $todoId: ID!\n  $input: UpdateTodoNumberResponseInput!\n) {\n  todo(todoId: $todoId) {\n    updateNumberResponse(input: $input) {\n      isResponseCompleted\n      response {\n        __typename\n        ... on TodoResponseNumber {\n          value\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4b77c20e1b3e718175a447ea74775109";

export default node;
